export default {
  notification: {
    success: {
      copy: 'Conteúdo copiado com sucesso.',
    },
    error: {
      copy: 'Conteúdo não pode ser copiado.',
    },
  },
  label: {
    tooltip: {
      copy: 'Clique para copiar o conteúdo.',
    },
    button: 'Copiar',
  },
};
